import React from "react";
import commonService from "../../../services/common-service";

const CheckoutCart = ({ cartItems, symbol, rate, currency }) => {
  return cartItems.map((cartItem, key) => {
    return (
      <div key={key} className="summary-item">
        <span className="product-name">{cartItem.name}</span>{" "}
        <span className="product-price">
          {cartItem.discountList !== undefined &&
          cartItem.discountList !== null &&
          cartItem.discountList.length ? (
            <>
              <span className="old">
                {symbol}
                {` `}
                {commonService.getConvertedPrice(
                  cartItem.price,
                  rate,
                  currency,
                )}
              </span>
              <span className="">
                {symbol}
                {` `}
                {commonService.getConvertedPrice(
                  cartItem.specialPrice,
                  rate,
                  currency,
                )}
              </span>
            </>
          ) : (
            <span className="">
              {symbol}
              {` `}
              {commonService.getConvertedPrice(cartItem.price, rate, currency)}
            </span>
          )}
        </span>
      </div>
    );
  });
};

export default CheckoutCart;
